import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { axiosInstance as axios } from '../../utils/axios';
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  meta: null,
  params: {
    page: 1,
    active: true,
    deleted: false,
  },
  record: null,
};

const slice = createSlice({
  name: 'hrHoliday',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getHolidaysSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.meta = action.payload.meta;
      state.error = false;
    },
    getHolidaySuccess(state, action) {
      state.isLoading = false;
      state.record = action.payload;
      state.error = false;
    },
    createHolidaySuccess(state, action) {
      state.isLoading = false;
      state.data = [...state.data, action.payload];
      state.error = false;
    },
    updateHolidaySuccess(state, action) {
      state.record = action.payload;
      state.isLoading = false;
      state.data = map(state.data, (_record) => (_record.id === action.payload.id ? action.payload : _record));
      state.params = { ...state.params };
      state.error = false;
    },
    deleteHolidaySuccess(state, action) {
      state.isLoading = false;
      state.data = filter(state.data, (r) => r.id !== action.payload.id);
      state.error = false;
    },
    setParams(state, action) {
      state.params = action.payload;
    },
    refreshParams(state) {
      state.params = { ...state.params };
    },
  },
});

export default slice.reducer;
export const { setParams, refreshParams } = slice.actions;

// ----------------------------------------------------------------------

export function getHolidays(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/hr/official-holiday/', { params });
      dispatch(slice.actions.getHolidaysSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return error;
    }
  };
}

export function getHoliday(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/hr/official-holiday/${id}/`);
      dispatch(slice.actions.getHolidaySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createHoliday(record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/hr/official-holiday/', record);
      dispatch(slice.actions.createHolidaySuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateHoliday(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/hr/official-holiday/${id}/`, record);
      dispatch(slice.actions.updateHolidaySuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteHoliday(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`/hr/official-holiday/${id}/`);
      dispatch(slice.actions.deleteHolidaySuccess({ id }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function actionHistoryHoliday(id, data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/hr/official-holiday/${id}/history/`, data);
      dispatch(slice.actions.updateHolidaySuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
